// 车船
const CarShip = () => import('@/components/CarShip')
// 新车
const NewCarIndex = () => import('@/components/carship/NewCarIndex')
const NewCarDetail = () => import('@/components/carship/NewCarDetail')
const ErCarIndex = () => import('@/components/carship/ErCarIndex')
const ErCarDetail = () => import('@/components/carship/ErCarDetail')
const ZuCarIndex = () => import('@/components/carship/ZuCarIndex')
const ZuCarDetail = () => import('@/components/carship/ZuCarDetail')
const NewShipIndex = () => import('@/components/carship/NewShipIndex')
const NewShipDetail = () => import('@/components/carship/NewShipDetail')
const ErShipIndex = () => import('@/components/carship/ErShipIndex')
const ErShipDetail = () => import('@/components/carship/ErShipDetail')
const ZuShipIndex = () => import('@/components/carship/ZuShipIndex')
const ZuShipDetail = () => import('@/components/carship/ZuShipDetail')

export default {
  path: '/carship',
  name: 'Carship',
  component: CarShip,
  meta: {
    title: '万知车船'
  },
  redirect: '/carship/newcar/',
  children: [
    {
      path: '/carship/newcar/',
      name: 'NewCar',
      redirect: '/carship/newcar/index/info',
      meta: {
        title: '万知车船'
      },
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/newcar/index/:tab',
          name: 'NewCarIndex',
          meta: {
            title: '万知车船'
          },
          component: NewCarIndex
        },
        {
          path: '/carship/newcar/detail/:tab/:id',
          name: 'NewCarDetail',
          meta: {
            title: '万知车船'
          },
          component: NewCarDetail
        }
      ]
    },
    {
      path: '/carship/ercar/',
      name: 'ErCar',
      redirect: '/carship/ercar/index/info',
      meta: {
        title: '万知车船'
      },
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/ercar/index/:tab',
          name: 'ErCarIndex',
          meta: {
            title: '万知车船'
          },
          component: ErCarIndex
        },
        {
          path: '/carship/ercar/detail/:tab/:id',
          name: 'ErCarDetail',
          meta: {
            title: '万知车船'
          },
          component: ErCarDetail
        }
      ]
    },
    {
      path: '/carship/zucar/',
      name: 'ZuCar',
      meta: {
        title: '万知车船'
      },
      redirect: '/carship/zucar/index/info',
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/zucar/index/:tab',
          name: 'ZuCarIndex',
          meta: {
            title: '万知车船'
          },
          component: ZuCarIndex
        },
        {
          path: '/carship/zucar/detail/:tab/:id',
          name: 'ZuCarDetail',
          meta: {
            title: '万知车船'
          },
          component: ZuCarDetail
        }
      ]
    },
    {
      path: '/carship/newship/',
      name: 'NewShip',
      meta: {
        title: '万知车船'
      },
      redirect: '/carship/newship/index/info',
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/newship/index/:tab',
          name: 'NewShipIndex',
          meta: {
            title: '万知车船'
          },
          component: NewShipIndex
        },
        {
          path: '/carship/newship/detail/:tab/:id',
          name: 'NewShipDetail',
          meta: {
            title: '万知车船'
          },
          component: NewShipDetail
        }
      ]
    },
    {
      path: '/carship/ership/',
      name: 'ErShip',
      meta: {
        title: '万知车船'
      },
      redirect: '/carship/ership/index/info',
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/ership/index/:tab',
          name: 'ErShipIndex',
          meta: {
            title: '万知车船'
          },
          component: ErShipIndex
        },
        {
          path: '/carship/ership/detail/:tab/:id',
          name: 'ErShipDetail',
          meta: {
            title: '万知车船'
          },
          component: ErShipDetail
        }
      ]
    },
    {
      path: '/carship/zuship/',
      name: 'ZuShip',
      redirect: '/carship/zuship/index/info',
      meta: {
        title: '万知车船'
      },
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: '/carship/zuship/index/:tab',
          name: 'ZuShipIndex',
          meta: {
            title: '万知车船'
          },
          component: ZuShipIndex
        },
        {
          path: '/carship/zuship/detail/:tab/:id',
          name: 'ZuShipDetail',
          meta: {
            title: '万知车船'
          },
          component: ZuShipDetail
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/carship.js